export enum LeagueType {
  Bronze = 'bronze',
  Silver = 'silver',
  Gold = 'gold',
}
